import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import Markdown from "react-markdown";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@mantine/core";
import Divider from "@material-ui/core/Divider";
import MemberForm from "../MemberForm/form";
import { AppContext, TOAST } from "../../context";
import initialValues from "./initialValues";
import UploadPhoto from "../registermember/uploadPhoto";
import { uploadPhoto64, registerTicket } from "../../infrastructure/actions";

let source;

const useStyles = makeStyles({
  container: {
    maxWidth: "1024px",
    width: "100%",
    margin: "16px auto",
    "@media(max-width: 1024px)": {
      margin: "0 auto",
    },
  },
  linkText: {
    color: "red",
    "&:hover": {
      cursor: "pointer",
    },
  },
  divider: {
    margin: "16px 0",
  },
  paper: {
    padding: "16px",
    minHeight: "calc(100vh - var(--header-height) - 32px)",
    "@media(max-width: 576)": {
      minHeight: "calc(100vh - var(--header-height-xs) - 32px)",
    },
  },
  paperWithNav: {
    padding: "16px",
    minHeight: "calc(100vh - var(--header-height) - 96px)",
    "@media(max-width: 1024px)": {
      minHeight: "calc(100vh - var(--header-height) - 64px)",
    },
    "@media(max-width: 768px)": {
      minHeight: "calc(100vh - var(--header-height))",
    },
    "@media(max-width: 576px)": {
      minHeight: "calc(100vh - var(--header-height-xs) - 32px)",
    },
  },
  actionContainer: {
    display: "flex",
    "& button": {
      marginRight: "16px",
    },
  },
});

const Ticket = (props) => {
  const classes = useStyles();
  const [topText, setTopText] = useState("");
  const [bottomText, setBottomText] = useState("");
  const [indexText, setIndexText] = useState("");
  const [uploaded, setUploaded] = useState(false);
  const { dispatch } = useContext(AppContext);
  const { language, fieldInfo, success, url, config } = useSelector(
    (state) => ({
      fieldInfo: state.infrastructure.config.fieldInfo,
      language: state.language,
      success: state.infrastructure.success,
      url: state.infrastructure.url,
      config: state.infrastructure.config,
    })
  );
  const rdxDispatch = useDispatch();

  useEffect(() => {
    let CancelToken = axios.CancelToken;
    source = CancelToken.source();
    let textUrl = "/ee-static/members/Texts/RegisterTicket";
    axios
      .all([
        axios.get(`${textUrl}/index.md`, {
          cancelToken: source.token,
        }),
        axios.get(`${textUrl}/Success/top.md`, {
          cancelToken: source.token,
        }),
        axios.get(`${textUrl}/Success/bottom.md`, {
          cancelToken: source.token,
        }),
      ])
      .then(
        axios.spread((index, top, bottom) => {
          setIndexText(index.data);
          setTopText(top.data);
          setBottomText(bottom.data);
        })
      )
      .catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
        }
      });

    return () => source.cancel("Component Is Unmounting");
  }, []);

  const callback = (response, actions, type) => {
    if (response.status >= 400) {
      response.text().then((text) =>
        dispatch({
          type: TOAST,
          payload: {
            text: text
              ? language.Toasts[text]
                ? language.Toasts[text]
                : text
              : "Något gick fel",
            variant: "error",
          },
        })
      );
      return actions.setSubmitting(false);
    }
    if (type === "photo") {
      dispatch({
        type: TOAST,
        payload: {
          text: language.Toasts.registerMemberPhotoSubmitSuccess,
          variant: "success",
        },
      });
      return setUploaded(true);
    }
    dispatch({
      type: TOAST,
      payload: {
        text: language.Toasts.registerTicketSubmitSuccess,
        variant: "success",
      },
    });
    actions.resetForm();
  };

  const handleRegisterTicket = (v, actions) => {
    const id = v.id;
    let values = {
      firstname: v.firstname,
      lastname: v.lastname,
      civicRegistrationNumber: v.civicRegistrationNumber,
      email: v.email,
      zipCode: v.zipCode,
    };
    if (v.cellPhone) {
      values = { ...values, cellPhone: v.cellPhone };
    }

    return rdxDispatch(
      registerTicket(id, values, null, (response) =>
        callback(response, actions)
      )
    );
  };

  const handlePhoto = (photoFile) => {
    rdxDispatch(
      uploadPhoto64(url, photoFile, null, (response) =>
        callback(response, null, "photo")
      )
    );
  };

  if (success) {
    return (
      <div className={classes.container}>
        {uploaded || config.hidePhoto ? (
          <>
            <Markdown
              source={bottomText}
              escapeHtml={false}
              skipHtml={false}
              className="register-member__bottom-text"
            />
            <Divider className={classes.divider} />
            <div className={classes.actionContainer}>
              <Button
                variant="outlined"
                onClick={() => window.location.reload()}
                className="members__index__button"
                color="dark"
              >
                {language.RegisterMoreTickets}
              </Button>
              <Button
                variant="outlined"
                onClick={() =>
                  window.location.replace(process.env.PUBLIC_URL + "/")
                }
                className="members__index__button"
                color="dark"
              >
                Hem
              </Button>
            </div>
          </>
        ) : (
          <>
            <Markdown
              source={topText}
              escapeHtml={false}
              skipHtml={false}
              className="register-member__top-text"
            />
            <Divider className={classes.divider} />
            <UploadPhoto savePhoto={handlePhoto} />
          </>
        )}
      </div>
    );
  }

  return (
    <div className={classes.container}>
      <Markdown
        source={indexText}
        escapeHtml={false}
        skipHtml={false}
        className="register-ticket__index-text"
      />
      <MemberForm
        fieldInfo={fieldInfo}
        language={language}
        handleSubmit={(values, actions) =>
          handleRegisterTicket(values, actions)
        }
        initialValues={initialValues}
        ticket={true}
      />
    </div>
  );
};

export default Ticket;
